import React from "react";
import { List, Button, Typography } from "antd";
import { useUserProfileGate } from "../../../../hooks/useUserProfileGate";
import { customLogger } from "../../../../utils/Logger";
import "./index.scss";

const { Title, Text } = Typography;

const data = [
  { id: "1", title: "Top Up", description: "Instant top-up, hassle-free" },
  {
    id: "2",
    title: "Purchase Number",
    description: "Number speak louder than words - choose yours!",
  },
  {
    id: "3",
    title: "Calling Add-ons",
    description: "Supercharge your call—because basic is boring!",
  },
  {
    id: "4",
    title: "Sms Add-ons",
    description: "Supercharge your call—because basic is boring!",
  },
];

interface AddonListProps {
  setCurrentScreen: any;
}

const AddonList: React.FC<AddonListProps> = ({ setCurrentScreen }) => {
  const { gate, modal } = useUserProfileGate();

  const handleClick = async (id: string) => {
    try {
      const res = await gate();
      if (res) {
        switch (id) {
          case "1":
            setCurrentScreen("top-up");
            break;
          case "2":
            setCurrentScreen("purchase-number");
            break;
          case "3":
            setCurrentScreen("call-addons");
            break;
          case "4":
            setCurrentScreen("sms-addons");
            break;
          default:
            console.warn("Invalid ID");
        }
      }
    } catch (err: any) {
      customLogger(err);
    }
  };

  return (
    <>
      <List
        className="addon-list"
        dataSource={data}
        renderItem={(item) => (
          <List.Item className="addon-item">
            <div>
              <Title level={5} className="addon-title">
                {item.title}
              </Title>
              <Text className="addon-description">{item.description}</Text>
            </div>
            <Button
              onClick={() => handleClick(item.id)}
              type="text"
              className="addon-button"
            >
              Add
            </Button>
          </List.Item>
        )}
      />
      {modal}
    </>
  );
};

export default AddonList;
